import { TranslateResult } from 'vue-i18n';
import IDictionary from '@/ship/Models/IDictionary';

export interface IFilter<_Ty = unknown> {
    label?: string | TranslateResult;
    path: string;
    defaultValue?: _Ty;
    type: FilterPanelSlotType;
    bind?: IDictionary;
    style?: string;
    placeholder?: string | TranslateResult;
}

export enum FilterPanelSlotType {
    Clear = 'clear',
    Save = 'save',
    Empty = '',
    Select = 'VSelect',
    Input = 'VInput',
    InputNumeric = 'VInputNumeric',
    Apply = 'apply',
    DatePicker = 'VDatePicker',
    LabeledCheckbox = 'VLabeledCheckbox',
}

export type FilterElementSlot = Filter | Pick<IFilter, 'type'>;

export class Filter<_Ty = unknown> implements IFilter {
    public label: string | TranslateResult = '';
    public path = '';
    public defaultValue: _Ty | null = null;
    public bind = {};
    public type = FilterPanelSlotType.Empty;
    public style = '';
    public placeholder: string | TranslateResult = '';

    public constructor(
        path: string,
        label: TranslateResult,
        defaultValue: _Ty,
        type: FilterPanelSlotType = FilterPanelSlotType.Select,
        bind: IDictionary = {},
        style: string = '',
        placeholder: string | TranslateResult = '',
    ) {
        this.path = path;
        this.label = label;
        this.defaultValue = defaultValue;
        this.type = type;
        this.bind = bind;
        this.style = style;
        this.placeholder = placeholder;
    }

    public static emptyElement(style: string = '') {
        return { type: FilterPanelSlotType.Empty, style };
    }

    public static clearButton(style: string = '') {
        return { type: FilterPanelSlotType.Clear, style };
    }

    public static saveButton(style: string = '') {
        return { type: FilterPanelSlotType.Save, style };
    }

    public static applyButton(style: string = '') {
        return { type: FilterPanelSlotType.Apply, style };
    }
}

export default Filter;
